import { render, staticRenderFns } from "./CircleDiagram.vue?vue&type=template&id=150fb814&"
import script from "./CircleDiagram.vue?vue&type=script&lang=ts&"
export * from "./CircleDiagram.vue?vue&type=script&lang=ts&"
import style0 from "./CircleDiagram.vue?vue&type=style&index=0&id=150fb814&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports